import { SegmentedControl } from '../ui/SegmentedControl';

export type StandingsView = 'live' | 'league' | 'season' | 'friends';

const VIEWS: { key: StandingsView; label: string }[] = [
  { key: 'live', label: 'Division' },
  { key: 'league', label: 'League' },
  { key: 'season', label: 'Season' },
  { key: 'friends', label: 'Friends' }
];

export function StandingsSegment({
  active,
  onChange
}: {
  active: StandingsView;
  onChange: (view: StandingsView) => void;
}) {
  return (
    <SegmentedControl
      value={active}
      onChange={onChange}
      options={VIEWS}
      layoutId="standings-segment-pill"
      trackClassName="rounded-[13px] bg-[#E6E6EC] p-1"
      itemClassName="rounded-[9px]"
    />
  );
}
